/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import {
  EmailInput,
  TextInput,
  PasswordInput,
  SelectInput,
  PhoneNumberInput,
  CountrySelectInput,
} from './components';
import './styles.css';
import { parse } from 'tldts';
import emailProviders from 'email-providers/all.json';
// import {
//   CountrySelectInput,
//   PhoneNumberInput,
// } from '@/widgets/tweety-widget-react-main/components';

export interface IFormCompProps {
  fields?: any;
  initialData?: any;
  isPasswordField?: boolean;
  submitButtonLabel?: string;
  onFormSubmit?(payload: any): void;
  renderSubmitButton?(): void;
  labelColor?: string;
  employeetype?: any;
  isOwner?: boolean;
}

export const FormComp = (props: IFormCompProps) => {
  const {
    isPasswordField,
    fields,
    initialData,
    submitButtonLabel,
    onFormSubmit,
    renderSubmitButton,
    isOwner,
    employeetype,
  } = props;
  const [formData, updateFormData] = useState<any>(initialData ?? {});
  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [passwordErr, setPasswordErr] = useState<any>(false);
  const [mailErr, setmailErr] = useState<any>(false);

  console.log('passwordErr,', passwordErr, formData[fields?.password?.id]);
  const _renderSubmitButton = () => {
    if (renderSubmitButton) {
      return renderSubmitButton();
    }
    return (
      <div className="mt-3">
        <Button
          variant="secondary"
          type="submit"
          className="mt-2 animate-up-2"
          style={{
            width: '50%',
            height: '40px',
            fontWeight: 'bold',
          }}
        >
          {submitButtonLabel}
        </Button>
      </div>
    );
  };
  // const isPersonalEmail = (email: string): boolean => {
  //   const domain = parse(email).domain;
  //   return domain ? emailProviders.includes(domain) : false;
  // };

  const handleSubmit = (e?: any) => {
    const form = e.currentTarget;
    const isValid = form.checkValidity();
    e.preventDefault();
    e.stopPropagation();
    let hasError = false;
    const errorsObj: any = {};
    // console.log('suga', isPersonalEmail(formData[fields?.email?.id]));
    // let _fields = [];
    // _fields = fields;
    if (isOwner && !formData['userType']) {
      errorsObj['userType'] = true;
      hasError = true;
    } else {
      hasError = false;
    }

    if (!isOwner && formData[fields?.nationality?.id] === undefined) {
      errorsObj[fields?.nationality?.id] = true;
      hasError = true;
    }

    if (!isOwner && formData[fields?.citizenship?.id] === undefined) {
      errorsObj[fields?.citizenship?.id] = true;
      hasError = true;
    }

    console.log('li->', hasError, isValid);
    setValidated(true);
    if (!hasError && isValid) {
      setErrors({});
      console.log('formData', formData);
      if (formData?.email) {
        formData.email = formData?.email.toLowerCase();
      }
      onFormSubmit && onFormSubmit(formData);
    } else {
      console.log('suspect->signup', errorsObj);
      window?.scrollTo(0, 0);
      setErrors(errorsObj);
    }
  };
  console.log(
    'errors[fields?.password?.id]',
    errors[fields?.password?.id] === true
      ? passwordErr
        ? fields?.password?.errorText1
        : fields?.password?.errorText
      : fields?.password?.errorText
  );
  const handleCompChange = (id: string, payload: any) => {
    if (id && payload && errors[id] && payload !== '') {
      delete errors[id];
    }
    updateFormData({
      ...formData,
      [id]: payload,
    });
  };
  const _renderLayout = () => {
    return (
      <Row key={`layout-1-row-default-layout`}>
        {isOwner && (
          <Col key={`layout-1-columns-orgName`} sm={12} className="mb-0">
            <TextInput
              {...fields?.orgName}
              value={initialData?.orgName}
              onCompChange={handleCompChange}
            />
          </Col>
        )}

        {isOwner && employeetype !== 'roe' && (
          <Col key={`layout-1-columns-userType`} sm={12} className="mb-0">
            <SelectInput
              id={'userType'}
              label={'User Type'}
              required={true}
              hasError={!!errors['userType']}
              errorText={'This field is required'}
              options={[
                {
                  id: 'owner',
                  label: 'Owner',
                },
                {
                  id: 'admin',
                  label: 'Admin',
                },
                {
                  id: 'agent',
                  label: 'HR Agent',
                },
              ]}
              onCompChange={handleCompChange}
              value={initialData?.userType}
            />
          </Col>
        )}
        {employeetype === 'roe' && (
          <Col key={`layout-1-columns-userType`} sm={12} className="mb-0">
            <SelectInput
              id={'userType'}
              label={'User Type'}
              required={true}
              hasError={!!errors['userType']}
              errorText={'This field is required'}
              options={[
                {
                  id: 'owner',
                  label: 'Owner',
                },
                {
                  id: 'admin',
                  label: 'Admin',
                },
                {
                  id: 'agent',
                  label: 'HR Agent',
                },
              ]}
              value={initialData?.userType}
              onCompChange={handleCompChange}
            />
          </Col>
        )}

        {
          <Col key={`layout-1-columns-trn`} sm={12} className="mb-0">
            <TextInput
              {...fields?.trn}
              value={initialData?.trn}
              onCompChange={handleCompChange}
            />
          </Col>
        }
        {!isOwner && (
          <Col key={`layout-1-columns-nationality`} sm={12} className="mb-0">
            <CountrySelectInput
              {...fields?.nationality}
              value={initialData?.nationality}
              onCompChange={handleCompChange}
              hasError={!!errors[fields?.nationality?.id]}
              errorText={'This field is required'}
            />
          </Col>
        )}
        {!isOwner && (
          <Col key={`layout-1-columns-citizenship`} sm={12} className="mb-4">
            <CountrySelectInput
              {...fields?.citizenship}
              value={initialData?.citizenship}
              onCompChange={handleCompChange}
              hasError={!!errors[fields?.citizenship?.id]}
              errorText={'This field is required'}
            />
          </Col>
        )}
      </Row>
    );
  };
  return (
    <>
      <Form
        noValidate
        validated={validated}
        className="mt-4"
        onSubmit={handleSubmit}
      >
        <>
          {_renderLayout()}
          {/*{_renderFormGroup()}*/}
          {_renderSubmitButton()}
        </>
      </Form>
    </>
  );
};

FormComp.defaultProps = {
  isPasswordField: false,
  fields: {
    email: {
      id: 'email',
      label: 'Email',
      required: true,
      placeholder: 'Enter your email address',
      errorText: 'Email is required',
      errorText1: 'Enter a valid Email',
      errorText2: 'Invalid email: either missing or a temporary email address',
      readOnly: false,
    },
    firstName: {
      id: 'firstName',
      label: 'First Name',
      required: true,
      placeholder: 'Enter your name',
      errorText: 'First Name is required',
      errorText1: 'First Name should be atleast 2 characters',
      pattern: `.{2,}`,
    },
    orgName: {
      id: 'orgName',
      label: 'Business Name',
      required: true,
      placeholder: 'Enter your Business name',
      errorText: 'Business Name is required',
      errorText1: 'Business Name should be atleast 5 characters',
    },
    trn: {
      id: 'trn',
      label: 'TRN',
      required: true,
      placeholder:
        'Enter your TRN , should not contain any special characters ex: 123456789',
      errorText: 'TRN is required',
      errorText1:
        'Invalid TRN. Must be 9 digits or 9 digits followed by / and 4 digits.',
      pattern: '^(\\d{9}|\\d{9}/\\d{4})$',
    },
    lastName: {
      id: 'lastName',
      label: 'Last Name',
      required: true,
      placeholder: 'Enter your last name',
      errorText: 'Last Name is required',
      errorText1: 'Last Name should be atleast 2 characters',
      pattern: `.{2,}`,
    },
    nationality: {
      id: 'nationality',
      label: 'Nationality',
      required: true,
      placeholder: 'Enter your Nationality',
      errorText: 'Nationality is required',
    },
    citizenship: {
      id: 'citizenship',
      label: 'Citizenship',
      required: true,
      placeholder: 'Enter your Citizenship',
      errorText: 'Citizenship is required',
    },
    phoneNumber: {
      id: 'phoneNumber',
      label: 'Mobile Number',
      required: true,
      placeholder:
        'Select your country code first and then Enter mobile number',
      errorText: 'Phone Number should contain at least 8 numbers',
    },
    password: {
      id: 'password',
      label: 'Password',
      required: true,
      errorText: 'Password is required',
      pattern: `/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\-]).{8,}$/`,
      errorText1:
        'Password should contain min 8 characters,1 upper case,1 lower case, 1 number and 1 special character ',
      placeholder: 'Enter password',
    },
    confirmPassword: {
      id: 'confirmPassword',
      label: 'Confirm Password',
      required: true,
      errorText: 'Confirm Password is required',
      placeholder: 'Enter password again',
    },
  },
};
